export const MAP_ID_SET = 'MAP_ID/SET';
